import React, { Component } from 'react';
import { Divider, FormGroup, NumericInput, Button, Intent, Switch } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class RateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expRate: 100,
      spRate: 100,
      dropRate: 20,
      goldRate: 10,
      soxRate: 3,
      saved: false
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Server Rate Editor & Multipliers
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure global Experience, Skill Points, Item Drop, Gold Drop, and SOX Drop rate multipliers.
        </p>

        <Divider className="mb-4" />

        {this.state.saved && (
          <div className="alert alert-success py-2 mb-4" style={{ fontSize: '0.85rem' }}>
            Global rate multipliers updated and broadcasted to Gateway Server!
          </div>
        )}

        <form onSubmit={this.handleSave}>
          <div className="row mb-3">
            <div className="col-md-4">
              <FormGroup label="EXP Rate Multiplier (x)">
                <NumericInput min={1} max={500} value={this.state.expRate} onValueChange={(val) => this.setState({ expRate: val })} fill />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup label="Skill Points (SP) Rate Multiplier (x)">
                <NumericInput min={1} max={500} value={this.state.spRate} onValueChange={(val) => this.setState({ spRate: val })} fill />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup label="Item Drop Rate Multiplier (x)">
                <NumericInput min={1} max={100} value={this.state.dropRate} onValueChange={(val) => this.setState({ dropRate: val })} fill />
              </FormGroup>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Gold Drop Rate Multiplier (x)">
                <NumericInput min={1} max={100} value={this.state.goldRate} onValueChange={(val) => this.setState({ goldRate: val })} fill />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup label="SOX Item Drop Multiplier (x)">
                <NumericInput min={1} max={50} value={this.state.soxRate} onValueChange={(val) => this.setState({ soxRate: val })} fill />
              </FormGroup>
            </div>
          </div>

          <div className="mb-4">
            <Switch label="Weekend Double EXP Event Active (2x Boost)" defaultChecked />
            <Switch label="VIP Subscribers 20% Rate Bonus" defaultChecked />
          </div>

          <Button intent={Intent.PRIMARY} type="submit" icon="floppy-disk" small text="Apply Server Rates" />
        </form>
      </SideMenuWrapper>
    );
  }
}
